<template>
  <div class="container">
    <div class="item" v-for="(item,index) in list" :key="index">
      <div class="productImg">
        <img :src="item.img" alt="MUTA软件系统 5G test multi-UE 多UE自动化测试"/>
      </div>
      <div class="productDescribe">
        <div class="title">{{item.title}}</div>
        <div class="describe">
          <!-- {{item.describe}} -->
          <div v-for="(item,index) in item.describe" :key="index" class="line">{{item.line}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      // list: [
      //   {
      //     img: "static/img/mutaSystem.jpg",
      //     title: "MUTA软件系统",
      //     describe: [
      //       { line: "MUTA软件系统是一套完整的通过商用/测试终端实现基站和移动网络测试的控制系统。 整个系统包含终端的驱动和连接模块，终端管理模块，测试结果数据库模块，以及测试编辑和集中管理界面。" },
      //       { line: "测试工程师使用MUTA可以管理大量终端同时发起业务测试，并得到所有终端完整的测试结果数据报告。测试人员也可以编辑并保存大量测试用例，实现基站的自动化功能和性能测试。" },
      //     ]
      //   }
      // ]
      list:this.$store.state.language.h
    };
  },
  watch:{
    '$store.state.language.h'(val){
      console.log(val)
      this.list = val
    }
  }
};
</script>

<style scoped>
.container {
  box-sizing: border-box;
  border-top: 1px solid white;
}
.item {
  width: 70%;
  margin: 0 auto;
  margin-top: 30px;
  overflow: auto;
  padding-bottom: 1rem;
}
.productImg {
  width: 17rem;
  height: 17rem;
  float: left;
}
.productImg img {
  width: 100%;
  height: 100%;
}
.productDescribe {
  margin-left: 3rem;
  width: calc(100% - 20rem);
  min-height: 17rem;
  float: left;
}
.title {
  height: 4rem;
  line-height: 4rem;
  text-indent: 2rem;
  font-size: 1.5rem;
}
.describe {
  min-height: 10rem;
  line-height: 2rem;
  text-indent: 2rem;
  font-size: 1.2rem;
}
.line {
  width: 100%;
  min-height: 2rem;
  line-height: 2rem;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/product/MUTAsystem.vue